export default class MvMotion {
    constructor(controller) {
        this.controller = controller;
        this.init();
    }

    init() {
        this.mvMotion();
    }

    mvMotion() {
        const mvTtl = gsap.timeline();
        mvTtl

            .to('.js-visible1', {
                delay: 0.6,
                autoAlpha: 1,
                ease: 'back.out(2.5)',
            })
            .to(
                '.js-visible2',
                {
                    autoAlpha: 0,
                    scale: 0.9,
                    ease: 'back.out(2.5)',
                },
                '-=1'
            )
            .to('.js-visible2', {
                    autoAlpha: 1,
                    scale: 1,
                    ease: 'back.out(2.5)',
                }
            )
            .to('.js-visible3', {
                autoAlpha: 1,
                ease: 'back.out(2.5)',
            },
            '<'
            )
            .to(
                '.js-visible4',
                {
                    autoAlpha: 0,
                    y: 30,
                    ease: 'back.out(2.5)',
                },
                '-=0.5'
            )
            .to('.js-visible4', {
                    autoAlpha: 1,
                    y: 0,
                    ease: 'back.out(2.5)',
                },
                '-=0.3'
            )
            
            .to(
                '.js-visible5',
                {
                    autoAlpha: 1,
                    duration: 8,
                    ease: 'back.out(2.5)',
                }
            );
    }
}
